'use strict';

import $ from 'jquery';
import { viewport } from './utilities/viewport';

$(document).ready(function() {

	let backToTopButton = $(".back-to-top");
	let footer = $('footer');

	backToTopButton.append("<span class='sr-only'>scroll to top</span>");
	backToTopButton.click(function() {
    $("body,html").animate({scrollTop:0},800);
	});

  $(window).scroll(function() {
    if($(this).scrollTop() != 0) {
      backToTopButton.addClass("show");
    } else {
			backToTopButton.removeClass("show");
		}

		let footerTop = footer.offset().top;
		let footerViewTop = footer[0].getBoundingClientRect().top;
		let buttonTop = backToTopButton.offset().top;

		if (footerTop < buttonTop + 24){
			backToTopButton.addClass('static');
		}
		if (footerViewTop > viewport().height - 64){
			backToTopButton.removeClass('static');
		}
  });
});
